<script lang="ts" setup>
import type { PageElementOfType } from '../page-builder'

const props = defineProps<{
  element: PageElementOfType<'heading'>
}>()

const domTag = computed(() => `h${props.element.data.size}`)
</script>

<template>
  <component
    :is="domTag"
    class="text-2xl font-semibold prose max-w-none text-primary-900"
    :class="{
      'text-3xl sm:text-4xl': element.data.size === 1,
      'text-2xl': element.data.size === 2,
      'text-xl': element.data.size === 3,
      'text-lg': element.data.size === 4,
    }"
    v-html="element.data.text"
  />
</template>
